import { Logo } from "@/frontend/shared/ui/Logo";
import { Tag } from "@/frontend/shared/ui/Tag";
import { Typography } from "@/frontend/shared/ui/Typography/Typography";
import styles from "./CompanyCell.module.scss";
import clsx from "clsx";
import { TCompanyComparedDetails } from "@/frontend/pages/ExpertPortfolioCompanyProfilePage/model/types/types";

export function CompanyCell({ field }: { field: TCompanyComparedDetails }) {
  const { name, headline, logoUrl, tags } = field;

  return (
    <div className={clsx(styles.company, styles.isFounderCompany)}>
      <div className={styles.companyInfo}>
        <Logo logo={logoUrl || ""} alt="logo" />
        <div className={styles.companyShortInfo}>
          <Typography variant="label-3" color="greyscale900">
            {name}
          </Typography>
          <Typography variant="body-3" color="greyscale600" className={styles.descriptionField}>
            {headline}
          </Typography>
        </div>
        {/* <div className={styles.tagsContainer}>
          {tags?.map((tag: { name: string }, index: number) => {
            return <Tag children={tag.name} size="small" key={index} />;
          })}
        </div> */}
      </div>
    </div>
  );
}
